import { render, staticRenderFns } from "./Usage.vue?vue&type=template&id=5589046a&"
import script from "./Usage.vue?vue&type=script&lang=js&"
export * from "./Usage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports